<div class="success-page position-relative overflow-hidden pt-4">
  <!-- Confetti particles -->
  <div class="confetti-container position-absolute start-0 w-100 h-100 overflow-hidden pe-none">
    <div class="confetti" *ngFor="let i of confettiPieces"></div>
  </div>

  <!-- Firework bursts -->
  <div class="position-absolute top-0 start-0 w-100 h-100 overflow-hidden pe-none">
    <div class="firework" *ngFor="let i of fireworks; let idx = index" [attr.data-index]="idx">
      <div class="firework-particle" *ngFor="let p of [1,2,3,4,5,6,7,8,9,10,11,12]"></div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8">
        <div class="card success-card shadow border-0 rounded-4 position-relative z-1 overflow-hidden">
          <div class="card-body text-center py-5">
            <!-- Success Icon with ring animation -->
            <div class="success-icon-wrapper position-relative d-flex align-items-center justify-content-center mx-auto mb-4">
              <div class="success-ring position-absolute w-100 h-100 rounded-circle"></div>
              <div class="success-ring delay-1 position-absolute w-100 h-100 rounded-circle"></div>
              <div class="success-ring delay-2 position-absolute w-100 h-100 rounded-circle"></div>
              <div class="checkmark-circle rounded-circle d-flex align-items-center justify-content-center">
                <i class="bi bi-check-lg display-6 text-white"></i>
              </div>
            </div>

            <!-- Success Message with slide-in -->
            <h2 class="fw-bold mb-2">{{ title }}</h2>
            <p class="text-body-secondary mb-4">{{ message }}</p>

            <!-- Entity Badge with bounce -->
            <div *ngIf="entities.length > 0" class="mb-4">
              <div class="d-inline-flex align-items-center gap-3 px-4 py-2 rounded-pill border border-2 border-primary-subtle bg-primary bg-opacity-25 shadow-sm">
                @for (entity of entities; track entity.type) {
                <i [class]="getEntityIcon(entity.type) + ' fs-5 text-primary'"></i>
                <span class="fw-semibold">{{ entity.name }}</span>
                }
              </div>
            </div>

            <!-- Details Section with stagger animation -->
            <div *ngIf="detailEntries.length > 0" class="col-md-8 mx-auto mb-4">
              <div class="bg-primary bg-opacity-25 border border-primary-subtle rounded-3 p-3">
                <div
                  *ngFor="let entry of detailEntries; let i = index"
                  class="detail-row d-flex justify-content-between align-items-center py-2"
                  [style.animation-delay]="(i * 0.1) + 's'"
                >
                  <span class="small text-body-secondary">{{ entry[0] }}</span>
                  <span class="fw-semibold">{{ entry[1] }}</span>
                </div>
              </div>
            </div>

            @if(additionalActions && additionalActions.length > 0) {
              <div class="d-flex justify-content-center">
             @for(action of additionalActions; track action) {
              <div>
                <button 
                type="button"
                class="btn btn-primary btn-action px-4 py-2 fw-medium rounded-3 mb-3 me-2"
                (click)="navigateToAction(action.route, action?.queryParams)"
                ><i class="bi"></i>
                {{ action.label }}
              </button>
              </div>
             }
            </div>
            }

            <!-- Action Buttons -->
            <div class="d-flex flex-column flex-sm-row justify-content-sm-center gap-3">
              @for (type of uniqueTypes; track type) {
              <button
                type="button"
                class="btn btn-primary btn-action px-4 py-2 fw-medium rounded-3"
                (click)="navigateToList(type)"
              >
                <i class="bi bi-list-ul me-2"></i>
                View All {{ getEntityTypeLabelPlural(type) }}
              </button>
            }

              <button
                *ngIf="createAnotherRoute"
                type="button"
                class="btn btn-outline-primary btn-action px-4 py-2 fw-medium rounded-3"
                (click)="createAnother()"
              >
                <i class="bi bi-plus-lg me-2"></i>
                Create Another
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
